export default {
  metadata: {
    version: '1.0.0',
    id: 'desktop-bottom-sheet-1.0.0',
    name: 'JDSDesktopBottomSheetInternal',
    platform: 'web'
  },
  hierarchy: {
    container: [
      {
        'root-container': [
          {
            'cancel-container': [
              {
                'back-container': ['back-jds_button']
              },
              'cancel-jds_button',
              'step-jds-text'
            ]
          },
          {
            'vertical-container': [
              'title-jds-text',
              'description-jds-text',
              'children-slot',
              {
                'cta-container': [
                  'primary-jds_action_button',
                  'secondary-jds_action_button'
                ]
              }
            ]
          }
        ]
      },
      {
        'custom-container': ['children-slot']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.end}',
      'align-items': '{alignItems.end}'
    },
    'root-container': {
      hidden: true,
      'z-index': 1,
      'flex-direction': '{d_5}',
      'justify-content': '{d_6}',
      'background-color': '{d_7}',
      'align-items': '{d_8}',
      'border-top-left-radius': '{d_9}',
      'border-top-right-radius': '{d_10}',
      width: '{custom_28}',
      'enter-animation-name': 'slideVerticallyUp',
      'exit-animation-name': 'slideVerticallyDown',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'translate-y': '{size.max}',
      transition: {
        property: ['translate-y'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    'cancel-container': {
      hidden: false,
      'flex-direction': '{d_11}',
      'justify-content': '{d_12}',
      'align-items': '{d_13}',
      width: '{d_14}',
      'padding-top': '{d_15}',
      'padding-bottom': '{d_16}',
      'padding-left': '{d_17}',
      'padding-right': '{d_18}',
      gap: '{d_19}'
    },
    'cancel-jds_button': {
      hidden: false,
      icon: 'ic_close',
      size: 'medium',
      kind: 'tertiary'
    },
    'vertical-container': {
      'flex-direction': '{d_20}',
      'justify-content': '{d_21}',
      'align-items': '{d_22}',
      'padding-left': '{d_23}',
      'padding-right': '{d_24}',
      width: '{d_25}'
    },
    'primary-jds_action_button': {
      hidden: false,
      kind: 'primary',
      size: 'medium',
      appearance: 'normal',
      state: 'normal',
      stretch: true
    },
    'secondary-jds_action_button': {
      hidden: false,
      kind: 'secondary',
      size: 'medium',
      appearance: 'normal',
      state: 'normal',
      stretch: true
    },
    'cta-container': {
      'flex-direction': '{d_28}',
      gap: '{d_29}',
      width: '{d_30}',
      'padding-bottom': '{d_31}',
      'padding-top': '{d_32}'
    },
    'back-container': {
      flex: 1,
      hidden: true
    },
    'back-jds_button': {
      kind: 'tertiary',
      icon: 'ic_back'
    },
    'custom-container': {
      hidden: true,
      'z-index': 1,
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'background-color': '{primaryBackground}',
      'border-top-left-radius': '{xl}',
      'border-top-right-radius': '{xl}',
      'padding-left': '{m}',
      'padding-right': '{m}',
      'padding-top': '{m}',
      'padding-bottom': '{m}',
      width: '{custom_28}',
      'translate-y': '{size.max}',
      transition: {
        property: ['translate-y'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    'title-jds-text': {
      'font-family': '{text_86}',
      color: '{text_20}',
      'font-size': '{text_85}',
      'line-height': '{text_87}',
      'letter-spacing': '{text_88}',
      'font-weight': '{text_89}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-bottom': '{d_26}'
    },
    'description-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-bottom': '{d_27}'
    },
    'step-jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true,
      'padding-right': '{d_33}'
    }
  },
  variant: {
    controlType: {
      stepper: {
        'back-container': {
          hidden: false
        },
        'cancel-jds_button': {
          hidden: true
        },
        'step-jds-text': {
          hidden: false
        }
      }
    },
    kind: {
      passive: {
        'root-container': {
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '{d_34}'
          }
        }
      }
    },
    close: {
      false: {
        'root-container': {
          'translate-y': 0,
          hidden: false
        }
      }
    },
    primaryCtaDisabled: {
      true: {
        'primary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    secondaryCtaDisabled: {
      true: {
        'secondary-jds_action_button': {
          state: 'disabled'
        }
      }
    }
  },
  combination: [
    {
      false: {
        true: {
          'custom-container': {
            hidden: false,
            'translate-y': 0
          },
          'root-container': {
            hidden: true,
            'translate-y': '{size.max}'
          },
          'vertical-container': {
            hidden: true
          }
        }
      }
    }
  ],
  combination_config: [['close', 'isCustom']],
  api: {
    config: {
      kind: {
        values: ['overlay', 'passive']
      },
      controlType: {
        values: ['normal', 'stepper']
      },
      isCustom: {
        values: [false, true]
      },
      close: {
        values: [true, false]
      },
      primaryCtaDisabled: {
        values: [false, true]
      },
      secondaryCtaDisabled: {
        values: [false, true]
      }
    },
    data: {
      'root-container': {
        'max-height': {
          type: 'number',
          name: 'height'
        }
      },
      'primary-jds_action_button': {
        label: {
          type: 'string',
          name: 'primaryCTA'
        }
      },
      'secondary-jds_action_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      },
      'description-jds-text': {
        value: {
          type: 'string',
          name: 'description'
        }
      },
      'step-jds-text': {
        value: {
          type: 'string',
          name: 'step_label'
        }
      }
    },
    children: {
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    events: {
      'root-container': {
        onClick: 'onBottomSheetClick',
        onSwipeDown: 'onClose'
      },
      'custom-container': {
        onClick: 'onBottomSheetClick',
        onSwipeDown: 'onClose'
      },
      'cancel-jds_button': {
        onClick: 'onCancel'
      },
      'primary-jds_action_button': {
        onClick: 'onPrimaryClick'
      },
      'secondary-jds_action_button': {
        onClick: 'onSecondaryClick'
      },
      'back-jds_button': {
        onClick: 'onBack'
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'dialog'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Bottom Sheet Content'
          },
          'aria-modal': {
            name: '_ariaModal'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'cancel-jds_button': {
        properties: {
          ariaLabel: {
            name: 'cancelButtonAriaLabel',
            value: 'Close Modal'
          }
        }
      },
      'back-jds_button': {
        properties: {
          ariaLabel: {
            name: 'backButtonAriaLabel',
            value: 'Click to go Back'
          }
        }
      },
      'primary-jds_action_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'secondary-jds_action_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
